import React from "react"
import { CaseStudyGridWrapper } from "./CaseStudyGrid.styles"
import CaseStudy from "../CaseStudy/CaseStudy"
import { graphql, useStaticQuery } from "gatsby"
import { statamicAssetToFixed } from "../../../utils/statamicAssets"

/**
 * @returns {[{
 *   title: string,
 *   quote: string,
 *   name: string,
 *   jobTitleCompany: string | null,
 *   stats: [{
 *     value: string,
 *     label: string
 *   }],
 *   logo: {
 *     fixed: {
 *       src: string,
 *       width: number,
 *       height: number
 *     },
 *     title: string
 *   } | null
 *   image: {
 *     fixed: {
 *       src: string,
 *       width: number,
 *       height: number
 *     },
 *     title: string
 *   } | null
 * }]}
 */
function useCaseStudies(){
  const query = useStaticQuery(graphql`
    query CaseStudiesPage {
      statamic {
        globalSet(handle: "case_studies_page") {
          ... on Statamic_GlobalSet_CaseStudiesPage {
            case_studies {
              ... on Statamic_Entry_CaseStudies_CaseStudy {
                id
                slug
                title
                quote
                name
                job_title_company
                stats {
                  value
                  label
                }
                logo {
                  url
                  permalink
                  ... on Statamic_Asset_Assets {
                    alt
                    width
                    height
                  }
                }
                image {
                  url
                  permalink
                  ... on Statamic_Asset_Assets {
                    alt
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const list = query?.statamic?.globalSet?.case_studies || []
  return list.map(cs => ({
    title: cs.title,
    quote: cs.quote || "",
    name: cs.name,
    jobTitleCompany: cs.job_title_company || null,
    stats: cs.stats || [],
    logo: statamicAssetToFixed(cs.logo, { w: 240, h: 90, fit: "contain" }, { width: 240, height: 90 }),
    image: statamicAssetToFixed(cs.image, { w: 600, q: 90 }, {}),
  }))
}

export default function(){
  return (
      <CaseStudyGridWrapper className="px-3">
        <div className="container">
          <h2>Case Study Overviews</h2>
          <div className="case-studies">
            {useCaseStudies().map((caseStudy, index) => (
              <CaseStudy key={index} caseStudy={caseStudy} alt={!!(index % 2)} />
            ))}
          </div>
        </div>
      </CaseStudyGridWrapper>
  );
}
